module.exports = __webpack_public_path__ + "img/question-right-sp.f286702.png";